import { useState, useEffect } from "react";
import DeviceOrientation, { Orientation } from "react-screen-orientation";

import Base from "components/Landscape/screens/Base";
import Portrait from "components/Portrait";
import { Redirect } from "react-router-dom";

function PortraitBase() {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  const [audioContextInstance, setAudioContextInstance] = useState(
    new AudioContext()
  );
  const [isPortrait, setIsPortrait] = useState(
    window.innerHeight >= window.innerWidth
  );

  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight >= window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isPortrait ? (
    <Portrait audioContextInstance={audioContextInstance} />
  ) : (
    <Redirect to="/" />
  );
  // <DeviceOrientation lockOrientation={"landscape"}>
  //   {/* Will only be in DOM in landscape */}
  //   <Orientation orientation="landscape" alwaysRender={false}>
  //     <Redirect to="/" />
  //   </Orientation>
  //   {/* Will stay in DOM, but is only visible in portrait */}
  //   <Orientation orientation="portrait" alwaysRender={false}>
  //     <Portrait audioContextInstance ={audioContextInstance} />
  //   </Orientation>
  // </DeviceOrientation>
}

export default PortraitBase;
